import { StatsigSessionReplayPlugin } from '@statsig/session-replay';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import { StatsigConsoleLogCaptureSettings } from 'src/constants/statsigAutoCapture';

type StatsigAutoCapturePluginRuntimeOptions = NonNullable<
  ConstructorParameters<typeof StatsigAutoCapturePlugin>[0]
> & {
  // Statsig's runtime supports this option, but the current package typings
  // do not expose it yet. Keep the compatibility shim isolated here.
  consoleLogAutoCaptureSettings?: StatsigConsoleLogCaptureSettings;
};

export const createStatsigPlugins = (
  consoleLogCaptureSettings?: StatsigConsoleLogCaptureSettings,
) => {
  const autoCaptureOptions: StatsigAutoCapturePluginRuntimeOptions = {};

  if (consoleLogCaptureSettings) {
    autoCaptureOptions.consoleLogAutoCaptureSettings =
      consoleLogCaptureSettings;
  }

  return [
    new StatsigAutoCapturePlugin(autoCaptureOptions),
    new StatsigSessionReplayPlugin(),
  ];
};
